import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale";
import { getYear, getMonth } from "date-fns";
import _ from "lodash";
import "../DatePicker.css"

function Calendar({ onDateSelect }) {
    const [selectedDate, setSelectedDate] = useState(null);

    const handleChange = (date) => {
        setSelectedDate(date);
        onDateSelect && onDateSelect(date);
    };

    const currentYear = getYear(new Date());
    const years = _.range(2015, currentYear + 1, 1);

    const months = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
    ];

    return (
        <div className="custom-react-datepicker__wrapper flex items-center justify-between ml-5 relative">
            <DatePicker
                locale={ko}
                selected={selectedDate}
                onChange={handleChange}
                dateFormat="yyyy-MM-dd"
                placeholderText="날짜를 선택하세요"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                popperPlacement="bottom-start"
                popperClassName="my-datepicker-popper"
                minDate={new Date(1995, 6, 1)}
                maxDate={new Date()}
                className="custom-datepicker border rounded-lg px-5 py-3 text-gray-700 focus:outline-none focus:border-blue-500 text-lg whitespace-nowrap"

                renderCustomHeader={({
                                         date,
                                         changeYear,
                                         changeMonth,
                                         decreaseMonth,
                                         increaseMonth,
                                         prevMonthButtonDisabled,
                                         nextMonthButtonDisabled,
                                     }) => (
                    <div className="custom-react-datepicker__select-wrapper flex items-center space-x-3 text-lg">
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                            <svg className="h-8 w-8 text-gray-500" width="24" height="24" viewBox="0 0 24 24"
                                 stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                                 stroke-linejoin="round" alt="prev" style={{color: '#dbdbdb'}}>
                                <path stroke="none" d="M0 0h24v24H0z"/>
                                <polyline points="11 7 6 12 11 17"/>
                                <polyline points="17 7 12 12 17 17"/>
                            </svg>
                        </button>
                        <div className="custom-react-datepicker__select-item flex items-center space-x-1">
                            <select
                                className="border p-2 rounded text-lg"
                                value={getYear(date)}
                                onChange={({ target: { value } }) => changeYear(Number(value))}
                            >
                                {years.map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                            <span>년</span>
                        </div>
                        <div style={{width : "5px"}}></div>
                        <div className="custom-react-datepicker__select-item flex items-center space-x-1">
                            <select
                                className="border p-2 rounded text-lg"
                                value={months[getMonth(date)]}
                                onChange={({ target: { value } }) =>
                                    changeMonth(months.indexOf(value))
                                }
                            >
                                {months.map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                            <span>월</span>
                        </div>
                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                            <svg className="h-8 w-8 text-gray-500" width="24" height="24" viewBox="0 0 24 24"
                                 stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                                 stroke-linejoin="round" alt="next" style={{color: '#dbdbdb'}}>
                                <path stroke="none" d="M0 0h24v24H0z"/>
                                <polyline points="7 7 12 12 7 17"/>
                                <polyline points="13 7 18 12 13 17"/>
                            </svg>
                        </button>
                    </div>
                )}
            />
        </div>
    );
}

export default Calendar;
